// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3Eenm","importantInfo":"styles_importantInfo__1gjOq"};